import { Select2 } from "ng-select2-component";
import { Pagination } from "./core";

export enum ParkingManagementConfigurationListItem {
    PaymentType = 'PaymentType'
}

export interface ParkingManagementConfigurationPayload {
    search?: string;
    limit?: number;
    page?: number;
    customer_type?: string;
    type?: string;
    customer_id?: number;
    company_id?: number;
    status?: string;
}

export class ParkingManagementConfigurationItem {
  id!: number;
  name!: string;
  status!: number;
  is_deleted!: number;
  created_at!: string | Date;
  updated_at!: string | Date;
  history!: History[];
}
export class ParkingManagementConfigurationCommonResponse {
  success!: boolean;
  message!: string;
}
export class ParkingManagementConfigurationResponse extends ParkingManagementConfigurationCommonResponse {
  data!: ParkingManagementConfigurationItem[];
  pagination!: Pagination;
}

export class AddParkingManagementConfigurationResponse extends ParkingManagementConfigurationCommonResponse {
  data!: ParkingManagementConfigurationItem;
}
export class ParkingManagementConfigurationError extends ParkingManagementConfigurationCommonResponse {
  error?: any;
}

export class DeletedParkingManagementConfiguration extends ParkingManagementConfigurationCommonResponse {
  id!: number;
}

export type MasterParkingManagementConfigurationItem = {
  [key in ParkingManagementConfigurationListItem]: {
    data: ParkingManagementConfigurationItem[];
    isLoading: boolean;
    ref?: Select2;
  };
};

